export default __webpack_public_path__ + "static/media/banner-home1.32d42de4.png";